






















































import {Component, Vue} from 'vue-property-decorator';
import G3wButton from '@/components/default/g3wButton.vue';
import CountryFlag from 'vue-country-flag';
import {mapGetters} from "vuex";

@Component({
    components: {G3wButton,CountryFlag},
    computed: {
        ...mapGetters({
            'info': 'info/info',
            'showAdmin': 'settings/showAdminButton'
        })
    }
})

export default class HeaderCOMUNE extends Vue {
    private showAdmin!: any;
    private switchLang() {
        if (this.$root.$i18n.locale == 'it') this.$root.$i18n.locale = 'en';
        else if (this.$root.$i18n.locale == 'en') this.$root.$i18n.locale = 'it';
        this.$router.replace({
            name: this.$route.name || '',
            params: {lang: this.$root.$i18n.locale}
        });

        window.location.reload();
    }

    get whoIs() {
        return this.$store.getters['me/me'];
    }

    get someoneIsLogged() {
        return this.$store.getters['me/someoneIsLogged'];
    }

    public logout() {
        const locale = this.$i18n.locale;
        this.$store.dispatch('me/logout', {locale});
        this.$store.dispatch('group/reset');
        if (this.$route.name !== 'home') {
            this.$router.push({name: 'home'});
        }
        this.$store.dispatch('menu/setVisibility', {v: false});
    }

    get width() {
        if (this.showAdmin && this.someoneIsLogged) return 'w-25';
        return 'w-33'
    }

    get Icon() {
        return this.someoneIsLogged ? 'sign-out-alt' : 'user-lock';
    }

    get flag() {
        switch (this.$i18n.locale) {
            case 'en':
                return 'it';
            case 'it':
                return 'gb';
        }
    }

    public mounted() {
        this.$store.dispatch('me/fetchWhoAmI',{locale:this.$i18n.locale});
    }
}
